import { createSlice } from '@reduxjs/toolkit';
import * as paymentReducers from 'Redux/Reducers/Payment';
import { SinglePaymentOffer, SubscriptionOffer } from 'api/graphql';
import { SetupIntent } from '@stripe/stripe-js';

export interface IPaymentState {
  selectedOffer: SinglePaymentOffer | SubscriptionOffer | null;
  billingDetails: {
    firstName: string;
    lastName: string;
    email: string;
    addressLine1: string;
    city: string;
    country: string;
    zipCode: string;
  };
  offers: {
    zpp: SubscriptionOffer | null;
    subscriptions: (SinglePaymentOffer | SubscriptionOffer)[];
  };
  purchase: {
    purchaseToken: string;
    userAutoAssigned: boolean;
  } | null;
  redeemVoucher: {
    token: string;
  } | null;
  terminateDetails: {
    uuid: string | null;
    receivedDate: string | null;
    email: string | null;
    confirmationPdfUrl: string | null;
  } | null;

  paymentIntentClientSecret: null | string;
  setupIntent: null | SetupIntent;
  paymentMethod: string;
  couponCode: string | null;
  updatedAt: number;
  openRequests: string[];
  failedRequests: string[];
}

export const paymentSlice = createSlice({
  name: 'payment',
  initialState: {
    selectedOffer: null,
    couponCode: null,
    billingDetails: {
      firstName: '',
      lastName: '',
      email: '',
      addressLine1: '',
      city: '',
      country: '',
      zipCode: '',
    },
    offers: {
      zpp: null,
      subscriptions: [],
    },
    terminateDetails: null,
    redeemVoucher: null,
    purchase: null,
    paymentMethod: 'card',
    paymentIntentClientSecret: null,
    setupIntent: null,
    updatedAt: 0,
    openRequests: [],
    failedRequests: [],
  },
  reducers: paymentReducers,
});
